import _ from 'lodash';

// 用于缓存Image数据
class SmartImageService {
    // 单/双视图
    static COMMON_VIEW = 'common';

    // 对比视图
    static COMPARE_VIEW = 'compare';

    constructor() {
        this.enableSmartFigures = true;

        this.cacheData = {};
        this.figuresCache = {};

        this.patentIdMap = {
            common: null,
            compare: {
                left: null,
                right: null,
            },
        };

        // this.patentId = null;

        // 文本feature开关
        this.textImageFeatureStatus = true;
    }

    setCurrentPatentId({ patentId, view, side }) {
        // this.patentId = patentId;
        // 单双视图
        if (view === SmartImageService.COMMON_VIEW) {
            const curPatentId = _.get(this.patentIdMap, SmartImageService.COMMON_VIEW);
            if (curPatentId !== patentId) {
                this.cacheData = {};
                this.patentIdMap[SmartImageService.COMMON_VIEW] = patentId;
                this.cacheData[patentId] = {};
            }
        // 对比视图
        } else if (view === SmartImageService.COMPARE_VIEW) {
            const curPatentId = _.get(this.patentIdMap, `${SmartImageService.COMPARE_VIEW}.${side}`);
            if (curPatentId !== patentId) {
                if (curPatentId) delete this.cacheData[curPatentId];
                this.patentIdMap[SmartImageService.COMPARE_VIEW][side] = patentId;
                this.cacheData[patentId] = {};
            }
        }
    }

    setImageCache({ imageId, data, patentId }) {
        this.cacheData[patentId][imageId] = data;
    }

    getImageCache({ imageId, patentId }) {
        // return _.get(this.cacheData, `${this.patentId}.${(imageId || '').replace('.', '\\.')}`);
        return (this.cacheData[patentId] || {})?.[imageId];
    }

    setFiguresCache(list = []) {
        list.forEach(item => {
            if (item.image_id) {
                // 如果有fig要把fig也加到缓存中
                this.figuresCache[item.image_id] = _.get(item, 'figure.parts', []);
            }
        });
    }

    getImageIdFromLabelId(labelId) {
        let imageId;
        for (var key in this.figuresCache) {
            const figures = this.figuresCache[key];
            let hasCurrentLabel = false;
            figures.forEach(item => {
                if (labelId === item.id) {
                    hasCurrentLabel = true;
                }
            });
            if (hasCurrentLabel) {
                imageId = key;
            }
            if (imageId) break;
        }
        return imageId;
    }

    getImageIdFromLabelText(labelText) {
        let imageId;
        for (var key in this.figuresCache) {
            const figures = this.figuresCache[key];
            let hasCurrentLabel = false;
            figures.forEach(item => {
                if (labelText === item.text) {
                    hasCurrentLabel = true;
                }
            });
            if (hasCurrentLabel) {
                imageId = key;
            }
            if (imageId) break;
        }
        return imageId;
    }

    cleanCache() {
        this.cacheData = {};
        this.figuresCache = {};
    }

    updateEnableSmartFigures(status) {
        this.enableSmartFigures = status;
    }

    updateTextImageFeatureStatus(status) {
        this.textImageFeatureStatus = status;
    }
}

const service = new SmartImageService();

export default service;
